import styled from 'styled-components'

const FormContainerWrapper = styled.div`
   
    width: 100%;
    flex: 1;
    .captcha-styles{
        max-width : 285px;        
    }
    .captcha-custom-styles{
        label{
            min-width: 130px !important;
        }
        input{
            height: 37px !important;
            min-width: 120px !important;
        }
        p{
            min-width: 140px !important;
        }
    }    
`

export {FormContainerWrapper};